module.exports = __webpack_public_path__ + "static/media/bgShare2@3x.9058c715.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare2@3x.png
// module id = 887
// module chunks = 0